var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"leave-active-class":"out","duration":200}},[_c('OzOverlay',{class:[
      'overflow-hidden',
      // Push content to bottom of the screen
      'flex',
      'flex-col',
      'justify-end',
      'items-center',
      // Can remove this once Oz page reset has been applied to all pages.
      'font-sans',
    ],attrs:{"is-spectral":_vm.isScrimSpectral,"scrim":_vm.xScrim ? 'modal' : null,"should-fade-in":_vm.shouldFadeIn,"z-index-class":_vm.zIndexClass,"dark-mode":_vm.darkMode},on:{"scrim-click":_vm.scrimClick,"scrim-esc":_vm.scrimEsc}},[_c('div',{ref:"modalContainer",class:[
        {
          'w-full': true,
          'max-h-full': true,
          'min-h-full': _vm.fullSize,
          'overflow-auto flex flex-col': true,
          'modal-container': true,
          'shadow-elevation-5': !_vm.fullSize,
          'rounded-none': _vm.isTouchingTopOfScreen,
          'rounded-3xl rounded-br-none rounded-bl-none': !_vm.isTouchingTopOfScreen,
          'full-size': _vm.fullSize,
          'bg-light-ui-100 dark:bg-dark-ui-100': _vm.darkMode === 'auto',
          'bg-light-ui-100 ': _vm.darkMode === false,
          'bg-dark-ui-100': _vm.darkMode === true,
          'pb-safe-inset-bottom': true,
        },
      ]},[_c('div',{class:[
          {
            'max-h-full flex flex-grow flex-col overflow-hidden': true,
          },
        ]},[(_vm.$slots.header)?_c('header',[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{class:{
            'flex flex-grow flex-col p-0 overflow-auto': true,
            'no-scrollbar': _vm.hideScrollbar,
          }},[_vm._t("body")],2)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }